var UseForCopy = {
    weight: 10,
    type: 'checkbox',
    defaultValue: false,
    label: 'Allow value propagation',
    tooltip: 'Enabling this checkbox will allow this field to be duplicated in new submission.',
    key: 'validate.isUseForCopy',
    input: true
};
export default UseForCopy;
